/*
  GP Custom documentation:
  Product-card media carousel click controls.

  Why this file exists:
  The product-card carousel is rendered inside the product image link. The visible carets should move
  the nested card Swiper, not open the product link and not advance a parent section carousel.

  How it works:
  - Listen for clicks that start on a `data-gp-card-media-carousel-arrow` element.
  - Find the closest `.gp-card-media-carousel`; the vendor Swiper initializer stores its instance on
    that element as `carousel.swiper`.
  - Stop the click from bubbling/defaulting so the product-card link and any parent carousel controls
    do not also handle the same click.
  - Move only the nested product-card media carousel with `slidePrev()` or `slideNext()`.

  This file intentionally does not initialize Swiper. That remains owned by the vendor slide module.
*/
(function () {
  const arrowSelector = "[data-gp-card-media-carousel-arrow]";
  const carouselSelector = ".gp-card-media-carousel";

  document.addEventListener("click", function (event) {
    const target = event.target instanceof Element ? event.target : null;
    const arrow = target?.closest(arrowSelector);
    if (!arrow) return;

    event.preventDefault();
    event.stopPropagation();

    const carousel = arrow.closest(carouselSelector);
    const swiper = carousel?.swiper;
    if (!swiper || swiper.destroyed) return;

    const direction = arrow.dataset.gpCardMediaCarouselArrow;
    if (direction === "prev") {
      swiper.slidePrev();
      return;
    }

    swiper.slideNext();
  }, true);
})();
